import { Box, Typography } from "@mui/material";
import { importServiceDescriptions } from "api/services/serviceDescription";
import DrawerWrapper from "components/DrawerWrapper";
import FileDrop from "components/FileDrop";
import LoadingButton from "components/LoadingButton";
import { snack } from "components/toast";
import { FILETYPES } from "data/constants";
import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { DialogProps } from "types";
import { handleError } from "utils/handleError";

function ImportServiceDescriptions({ open, setOpen }: DialogProps) {
  const queryClient = useQueryClient();
  const [file, setFile] = useState<File | null>(null);

  const { mutate, isLoading } = useMutation(importServiceDescriptions, {
    onSuccess: (res: any) => {
      snack.success(res?.data?.message || "Service Descriptions Imported Successfully");
      setOpen(false);
      setFile(null);
      queryClient.invalidateQueries("service-descriptions");
    },
    onError: (err: any) => {
      snack.error(handleError(err));
    },
  });

  const handleFiles = (files: File[]) => {
    setFile(files[0]);
  };

  const handleSubmit = () => {
    if (!file) {
      snack.error("Select a file");
      return;
    }

    const isValidFile =
      file.type === FILETYPES.SHEET1 ||
      file.type === FILETYPES.SHEET2 ||
      file.type === FILETYPES.SHEET3;

    if (!isValidFile) {
      snack.error("Invalid File Type, Only .xls or .xlsx files are accepted");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    mutate(formData);
  };

  return (
    <DrawerWrapper open={open} setOpen={setOpen} title="Bulk Import Service Descriptions">
      <FileDrop onChange={handleFiles} />
      <Box display="flex" justifyContent="space-between">
        <Typography variant="caption" color="rgba(0,0,0,0.7)">
          *Only .xls or .xlsx files are accepted
        </Typography>
        <a
          style={{ textDecoration: "none" }}
          href="https://vider-prod-bucket.s3.ap-south-1.amazonaws.com/ATOM+-+Professional+Service+Fees+List-1.xlsx"
        >
          <Typography variant="caption" color="secondary">
            Download Sample File
          </Typography>
        </a>
      </Box>
      <LoadingButton
        onClick={handleSubmit}
        variant="contained"
        loading={isLoading}
        disabled={isLoading}
        sx={{ mt: 3 }}
        fullWidth
        color="secondary"
        title="Import"
      />
    </DrawerWrapper>
  );
}

export default ImportServiceDescriptions;
